





























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {mapGetters} from "vuex";
import * as firebase from 'firebase/app';
import Starred from "@/components/Starred.vue";
import {EFalseTrue, ESettoreDescription} from "@/types";

@Component({
    components: {
        Starred
    },
    computed: {
        ...mapGetters({
            profile: 'profile',
            isWorker: 'isWorker',
            allAnnouncements: 'allAnnouncements',
            announcements: 'announcements'
        })
    },
    name: "Announcement"
})
export default class Announcement extends Vue {
    @Prop(String) readonly announcementUuid!: string;
    efalsetrue = EFalseTrue;
    esettoredesc = ESettoreDescription

    private profile?: any;
    private isWorker?: boolean;
    private allAnnouncements?: any[];
    private announcements?: any[];

    get isStarred() {
        return this.isWorker &&
            this.profile?.starredAnnouncements &&
            (this.profile.starredAnnouncements as string[]).indexOf(this.announcementUuid) > -1
    }

    get announcement() {
        if (this.isWorker) {
            return this.allAnnouncements?.find((item) => {
                return item.id == this.announcementUuid
            })
        } else {
            return this.announcements?.find((item) => {
                return item.id == this.announcementUuid
            })
        }

    }

    private toggleStarred(value: boolean) {
        let starredAnnouncements: string[] = this.profile?.starredAnnouncements || [];
        if (starredAnnouncements.indexOf(this.announcementUuid) === -1) {
            starredAnnouncements.push(this.announcementUuid)
        } else {
            for (let i = starredAnnouncements.length - 1; i >= 0; i--) {
                if (starredAnnouncements[i] === this.announcementUuid) {
                    starredAnnouncements.splice(i, 1);
                }
            }
        }
        firebase.firestore().collection('users')
            .doc(this.profile.id).update({starredAnnouncements: starredAnnouncements})
    }

}

